import script from "./acContextMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./acContextMenu.vue?vue&type=script&setup=true&lang=ts"

import "./acContextMenu.vue?vue&type=style&index=0&id=56c6ee59&lang=scss"

const __exports__ = script;

export default __exports__